import React, { useState } from 'react';
import '../css/Modal.css'; // Your custom styles

function ErrorUserPasswordModal({ isOpen, onClose, text }) {
  
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">

        <div style={{
          display: 'flex',
          justifyContent: 'space-evenly',
          flexDirection: 'column',
          marginTop: 20
        }}>
          <span
            style={{
              minWidth: '200px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              fontFamily: 'nunito sans',
              fontWeight: 700,
              marginBottom: 20
            }}>
            {text}
          </span>

          <div style={{
            display: 'flex',
            justifyContent: 'center'
          }}>
            <button className="cancel" onClick={onClose}>Cerrar</button>
          </div>
        </div>

      </div>
    </div>
  );
}

export default ErrorUserPasswordModal;